export default "__VITE_ASSET__BCtHhc$Y__"